import { arrayOf, bool, node, number, string } from 'prop-types';
import React from 'react';

import { BrandLinks } from '../../brands/Link';
import MerchantLabel from '../../merchants/Label';
import { MerchantLinks } from '../../merchants/Link';
import { UserLinks } from '../../users/Link';
import TargetSuppliersLabel from '../target-suppliers/Label';

export const detailViews = {
  brand: BrandLinks,
  user: UserLinks,
  merchant: MerchantLabel,
  zmsamMerchant: MerchantLinks,
  targetSuppliers: TargetSuppliersLabel,
};

const MissingDetailView = ({ ids, type }) => (
  <div>
    No detail view component found for {type}; IDs = {ids && ids.join(', ')}
  </div>
);

MissingDetailView.propTypes = {
  ids: arrayOf(number),
  type: string.isRequired,
};

MissingDetailView.defaultProps = {
  ids: [],
};

function AssociatedModelList(props) {
  const { type, ids, verbose, separator, ...rest } = props;
  const DetailView = detailViews[type];
  const detailView = DetailView ? (
    <DetailView ids={ids} separator={separator} verbose={verbose} {...rest} />
  ) : (
    <MissingDetailView type={type} ids={ids} {...rest} />
  );

  return <div className="d-inline-block">{ids.length ? detailView : ''}</div>;
}

AssociatedModelList.propTypes = {
  ids: arrayOf(number),
  type: string.isRequired,
  verbose: bool,
  separator: node,
};

AssociatedModelList.defaultProps = {
  ids: [],
  verbose: false,
  separator: <br />,
};

export default AssociatedModelList;
